module.exports = __webpack_public_path__ + "img/ai_person_remover2.a4ca253b.png";